import { fromJS } from 'immutable';
import { USER_PAGE_ACTIONS } from './actions';
import { formatMentorsToOptions } from './helpers';
import { DEFAULT_VALUES } from './consts';

export const initialState = fromJS({
  userData: {},
  userCourse: {},
  userMentors: [],
  allMentors: [],
  allBusinessUnits: [],
  personalProgram: {},
  loading: false,
  phoneUpdateLoading: false,
  phoneUpdateRevision: 0,
  toastType: null,
  error: false,
});

export const userPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_PAGE_ACTIONS.SET_LOADING_STATUS: {
      return state.set('loading', payload);
    }

    case USER_PAGE_ACTIONS.SET_PHONE_UPDATE_LOADING: {
      return state.set('phoneUpdateLoading', payload);
    }

    case USER_PAGE_ACTIONS.FINISH_PHONE_UPDATE: {
      const nextState = state
        .set('phoneUpdateLoading', false)
        .update('phoneUpdateRevision', (revision) => revision + 1);
      if (payload === undefined) return nextState;

      return nextState.set('userData', {
        ...state.get('userData'),
        phone: payload,
      });
    }

    case USER_PAGE_ACTIONS.SHOW_ERROR: {
      return state.set('error', true);
    }

    case USER_PAGE_ACTIONS.SET_ONE_USER: {
      return state
        .set('userData', payload)
        .set('userCourse', payload.course ?? DEFAULT_VALUES.COURSE)
        .set('userMentors', formatMentorsToOptions(payload.mentor ?? DEFAULT_VALUES.MENTORS))
    }

    case USER_PAGE_ACTIONS.SET_USER_PAGE_MENTORS: {
      return state.set('allMentors', payload);
    }

    case USER_PAGE_ACTIONS.SET_USER_PAGE_BUSINESS_UNITS: {
      return state.set('allBusinessUnits', payload);
    }

    case USER_PAGE_ACTIONS.SHOW_TOAST: {
      return state.set('toastType', payload);
    }

    default: {
      return state;
    }
  }
};
